import { AnyAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { StoreModel } from '@app/interfaces/store';
import { getStoreApi } from '@app/api/store.api';
import { showError } from '@app/utils/message';

export interface StoreState {
  data: StoreModel[];
  loading: boolean;
  error: string | null;
}

const initialState: StoreState = {
  data: [],
  loading: false,
  error: null,
};

// Thunks
export const getStores = createAsyncThunk<StoreModel[]>(
  'store/getStores',
  async (_, { rejectWithValue }) => {
    try {
      const stores = await getStoreApi()
      return stores || [];

    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  },
);

const isRejectedAction = (action: AnyAction) => {
  return action.type.endsWith('rejected');
};

// Slice
export const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStores.fulfilled, (state, action) => {
        state.data = action.payload
        state.loading = false;
      })
      .addMatcher(isRejectedAction, (state, action) => {
        state.loading = false;
        showError(action.payload?.message || action.payload?.error || action?.error?.message);
      });
    }
  }
);

export default storeSlice.reducer;